import React from 'react'
import ChipAutocomplete from '../../../atoms/ChipAutocomplete'
import { useUserAPI } from '../../../../providers/UserAPIProvider'

import useStyles from './styles'

const SearchUserModal = ({
  onUserFound,
  searchingGuests,
  user,
  noAdd,
  setFoundUser
}) => {
  const { allUsers } = useUserAPI()

  const [value, setValue] = React.useState([])

  const classes = useStyles()

  return (
    <>
      <div className={classes.root}>
        <div className='adorn'>Participant:</div>

        <div className={classes.input}>
          <ChipAutocomplete
            wrapSelection
            value={user ? (!noAdd ? [user] : value) : value}
            onChange={vals => {
              const users = vals.map(id => allUsers[id]).filter(Boolean)
              if (onUserFound) {
                onUserFound(users)
              }
              if (setFoundUser) {
                setFoundUser(users[users.length - 1])
              }
              setValue(vals)
            }}
            internal={!searchingGuests}
            autoFocus
          />
        </div>
      </div>
    </>
  )
}

export default SearchUserModal
